module.exports = __webpack_public_path__ + "img/13_3.f0600152.png";